import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'outline';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'md' | 'sm';
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  ...props
}) => {
  const base =
    size === 'sm'
      ? 'px-4 py-2 rounded-xl font-bold text-sm focus:outline-none transition active:scale-[0.99]'
      : 'w-full py-3 rounded-2xl font-extrabold text-base focus:outline-none transition active:scale-[0.99]';

  const variants: Record<ButtonVariant, string> = {
    primary: 'bg-sky-600 text-white hover:bg-sky-700',
    secondary:
      'bg-white text-gray-800 border border-gray-300 hover:bg-gray-100',
    outline:
      'bg-transparent text-gray-600 border border-gray-300 hover:bg-gray-50',
  };

  return (
    <button
      type={type}
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;